<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="组立" v-if="parentData.process_stage === 'check_process_zl'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zuliCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zuliCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zuliCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zuliCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zuliCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zuliCheckInfo.check_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zuliCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zuliCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[0]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zuliCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zuliCheckInfo.pictures_list" :preview-src-list="zuliCheckInfo.pictures_list"
                        v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zuliCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="前部品" v-if="parentData.process_stage === 'check_process_qb'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ qianbuCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ qianbuCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ qianbuCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ qianbuCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ qianbuCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ qianbuCheckInfo.check_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ qianbuCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ qianbuCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[1]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="qianbuCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in qianbuCheckInfo.pictures_list"
                        :preview-src-list="qianbuCheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ qianbuCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="玻璃" v-if="parentData.process_stage === 'check_process_bl'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ boliCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ boliCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ boliCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ boliCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ boliCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ boliCheckInfo.check_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ boliCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ boliCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div v-show="boliImage !== 'null'" style="display: flex;justify-content: center;">
              <el-image class="imageStyle1" :src="boliImage" :preview-src-list="[boliImage]" fit="fill"></el-image>
            </div>
            <div v-show="boliBangDingRecord.length !== 0">
              <div class="fontBold">玻璃绑定</div>
              <div class="nowrapDiv" style="margin-bottom: 10px" v-for="boliBangDing in boliBangDingRecord"
                   v-bind:key="boliBangDing.id">
                <div class="fontBold">位置{{ boliBangDing.position }}、玻璃编号：</div>
                <div style="color: red">{{ boliBangDing.boli_piece_no }}</div>
<!--                <el-select v-model="boliBangDing.boli_piece_no" filterable @change="updateBoliPieceNo(boliBangDing)" style="width: 120px;margin-right: 10px">
                  <el-option
                      v-for="item in boliBangDing.boliPieceNoList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>-->
                <div v-if="boliBangDing.skip" class="fontBold" style="margin-left: 5px">跳过安装备注：{{boliBangDing.remark}}</div>
              </div>
            </div>
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[2]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="boliCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in boliCheckInfo.pictures_list" :preview-src-list="boliCheckInfo.pictures_list"
                        v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ boliCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="后部品" v-if="parentData.process_stage === 'check_process_hb'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ houbuCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ houbuCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ houbuCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ houbuCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ houbuCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ houbuCheckInfo.check_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ houbuCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ houbuCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[3]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="houbuCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in houbuCheckInfo.pictures_list"
                        :preview-src-list="houbuCheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ houbuCheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="重点一" v-if="parentData.process_stage === 'zhongdian1'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zhong1CheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zhong1CheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zhong1CheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zhong1CheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zhong1CheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zhong1CheckInfo.check_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zhong1CheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zhong1CheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[5]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zhong1CheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zhong1CheckInfo.pictures_list"
                        :preview-src-list="zhong1CheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zhong1CheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="重点二" v-if="parentData.process_stage === 'zhongdian2'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zhong2CheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zhong2CheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zhong2CheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zhong2CheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zhong2CheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zhong2CheckInfo.check_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zhong2CheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zhong2CheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[6]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zhong2CheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zhong2CheckInfo.pictures_list"
                        :preview-src-list="zhong2CheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zhong2CheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="重点三" v-if="parentData.process_stage === 'zhongdian3'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ zhong3CheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ zhong3CheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ zhong3CheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ zhong3CheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ zhong3CheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ zhong3CheckInfo.check_user_name }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ zhong3CheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ zhong3CheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[7]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="zhong3CheckInfo.pictures !== null">
              <el-image v-for="imageUrl in zhong3CheckInfo.pictures_list"
                        :preview-src-list="zhong3CheckInfo.pictures_list" v-bind:key="imageUrl" class="imageStyle"
                        :src=imageUrl fit="fill"></el-image>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">备注：</div>
              <div>{{ zhong3CheckInfo.remark }}</div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="完成品" v-if="parentData.process_stage === 'check_process_wcp'">
        <div class="checkInfo">
          <div class="detail">
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">物件番号</div>
                <div>{{ wcpCheckInfo.wujian_id }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">物件名</div>
                <div>{{ wcpCheckInfo.wujian_name }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">批号</div>
                <div>{{ wcpCheckInfo.batch_no }}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">单元号</div>
                <div>{{ wcpCheckInfo.unit_no }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="width3 fontBold">单元种类</div>
              <div>{{ wcpCheckInfo.unit_type }}</div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查员</div>
                <div>{{ wcpCheckInfo.check_user_name}}</div>
              </div>
              <div class="detailDiv">
                <div class="width1 fontBold">检查时间</div>
                <div>{{ wcpCheckInfo.create_time }}</div>
              </div>
            </div>
            <div class="nowrapDiv">
              <div class="detailDiv">
                <div class="width1 fontBold">检查结果</div>
                <div>{{ wcpCheckInfo.resultText }}</div>
              </div>
            </div>
          </div>
          <div class="detail">
            <div v-show="wcpImage !== 'null'" style="display: flex;justify-content: center;">
              <el-image class="imageStyle1" :src="wcpImage" :preview-src-list="[wcpImage]" fit="fill"></el-image>
            </div>
            <!--            <div v-show="boliBangDingRecord.length !== 0">-->
            <!--              <div class="fontBold">玻璃绑定</div>-->
            <!--              <div class="nowrapDiv" style="margin-bottom: 10px" v-for="boliBangDing in boliBangDingRecord" v-bind:key="boliBangDing.id">-->
            <!--                <div class="fontBold">位置{{boliBangDing.position}}、玻璃编号：</div>-->
            <!--                <div style="color: red">{{ boliBangDing.boli_piece_no }}</div>-->
            <!--              </div>-->
            <!--            </div>-->
            <div v-show="zuliPointList.length !== 0" style="margin-bottom: 10px">
              <div class="nowrapDiv">
                <div class="fontBold">寸法检查:</div>
              </div>
              <div class="nowrapDiv" v-for="(sizeItem,index) in zuliPointList" v-bind:key="sizeItem.id">
                <div class="detailDiv">
                  <div class="fontBold">{{ index + 1 }}、测定处{{ sizeItem.point_name }}实测值：</div>
                  <div v-if="sizeItem.result === 'false'" style="color: red">{{ sizeItem.measured_value }}</div>
                  <div v-else>{{ sizeItem.measured_value }}</div>
                </div>
                <div class="detailDiv">
                  <div class="fontBold">容许范围：</div>
                  <div>{{ sizeItem.minValue }}~{{ sizeItem.maxValue }}</div>
                </div>
              </div>
            </div>

            <div v-show="diagonalInfo.length !== 0" style="margin-bottom: 10px">
              <div class="nowrapDiv">
                <div class="fontBold">对角线检查:</div>
              </div>
              <div class="nowrapDiv" v-for="(diagonalItem,index) in diagonalInfo" v-bind:key="diagonalItem.id">
                <div class="fontBold">{{ index + 1 }}、对角线{{ diagonalItem.position }}：</div>
                <div>{{ diagonalItem.value1 }}</div>
                <div style="margin-left: 20px">{{ diagonalItem.value2 }}</div>
                <div class="fontBold" style="margin-left: 20px">对角线差：{{ diagonalItem.absolute_value }}</div>
                <div style="margin-left: 20px">
                  <text class="fontBold">检查结果：</text>
                  <text v-if="diagonalItem.result === 'true'">合格</text>
                  <text v-else style="color: red">不合格</text>
                </div>
              </div>
            </div>

            <div class="nowrapDiv" v-for="(checkItem,index) in checkItemList[4]" v-bind:key="checkItem.id">
              <text>
                <text class="fontBold">
                  <text>{{ index + 1 }}、{{ checkItem.check_item_name }}</text>
                  <text v-if="checkItem.result !== 'true'">({{ checkItem.remark }})</text>
                  <text>：</text>
                </text>
                <text v-if="checkItem.result === 'true'">{{ checkItem.resultText }}</text>
                <text v-else style="color: red">{{ checkItem.resultText }}</text>
              </text>
            </div>
            <div class="nowrapDiv">
              <div class="fontBold">图片:</div>
            </div>
            <div v-show="wcpCheckInfo.pictures !== null">
              <el-image v-for="imageUrl in wcpCheckInfo.pictures_list" :preview-src-list="wcpCheckInfo.pictures_list"
                        v-bind:key="imageUrl" class="imageStyle" :src=imageUrl fit="fill"></el-image>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: "BusZuliZhiJianInfo",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      zuliCheckInfo: {},
      qianbuCheckInfo: {},
      boliCheckInfo: {},
      houbuCheckInfo: {},
      wcpCheckInfo: {},
      zhong1CheckInfo: {},
      zhong2CheckInfo: {},
      zhong3CheckInfo: {},
      checkItemList: [],
      boliBangDingRecord: [],
      boliImage: '',
      wcpImage: '',
      zuliPointList: [],
      diagonalInfo: [],
    }
  },
  methods: {
    async getZuliCheckInfo(stage) {
      let {data: res} = await this.$axios.get('/api/zuli/check/rollbackinfo?inId=' + this.parentData.in_id + '&stage=' + stage);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        if (stage === 0) {
          this.zuliCheckInfo = res.data
        } else if (stage === 1) {
          this.qianbuCheckInfo = res.data
        } else if (stage === 2) {
          this.boliCheckInfo = res.data
        } else if (stage === 3) {
          this.houbuCheckInfo = res.data
        } else if (stage === 4) {
          this.wcpCheckInfo = res.data
        } else if (stage === 5) {
          this.zhong1CheckInfo = res.data
        } else if (stage === 6) {
          this.zhong2CheckInfo = res.data
        } else if (stage === 7) {
          this.zhong3CheckInfo = res.data
        }
      }
      let {data: res1} = await this.$axios.get('/api/zuli/check/item/rollbacklist?stageId=' + stage + '&inId=' + this.parentData.in_id);
      if (res1.message !== "") {
        this.$message.error(res1.message);
      } else {
        this.checkItemList[stage] = res1.data
      }
    },
    async getZuliBoliBangDingRecord(stage) {
      let {data: res} = await this.$axios.get('/api/zuli/boli/bangding/rollbackrecord?stage=' + stage + '&inId=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        /*res.data.forEach((item)=>{
          this.getBoliPieceNoList(item).then((result)=>{
            item.boliPieceNoList = result
          })
        })*/
        this.boliBangDingRecord = res.data
      }
    },
    async getZuliImage(stage) {
      let {data: res} = await this.$axios.get('/api/zuli/point/image?wujianId=' + this.parentData.wujian_id + '&unitType=' + this.parentData.unit_type);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        if (stage === 2) {
          this.boliImage = res.data
        } else {
          this.wcpImage = res.data
        }
      }
    },
    async getZuliPointList() {
      let {data: res} = await this.$axios.get('/api/zuli/point/check/rollbackrecord?inId=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.zuliPointList = res.data
      }
    },
    async getZuliDiagonalInfo() {
      let {data: res} = await this.$axios.get('/api/zuli/diagonal/rollbackinfo?inId=' + this.parentData.in_id);
      if (res.message !== "") {
        this.$message.error(res.message);
      } else {
        this.diagonalInfo = res.data
      }
    },
    /*async getBoliPieceNoList(item){
      let {data: res} = await this.$axios.post('bus/datasource/getBoliPieceNoList',item);
      if (res.success) {
        return res.data.children
      }else {
        return []
      }
    },*/
    /*async updateBoliPieceNo(boliBangDing){
      this.parentData.pieceNo = boliBangDing.boli_piece_no
      this.parentData.boliBangDingId = boliBangDing.id
      let {data: res} = await this.$axios.post('bus/zuliZhiJianRecord/updateBoliPieceNo',this.parentData);
      if (res.success){
        this.$message.success("绑定成功!")
      }
    }*/
  },
  created() {
    if (this.parentData.process_stage === 'check_process_zl') {
      this.getZuliCheckInfo(0)
    }
    if (this.parentData.process_stage === 'check_process_qb') {
      this.getZuliCheckInfo(1)
    }
    if (this.parentData.process_stage === 'check_process_bl') {
      this.getZuliCheckInfo(2)
      this.getZuliBoliBangDingRecord(2)
      this.getZuliImage(2)
    }
    if (this.parentData.process_stage === 'check_process_hb') {
      this.getZuliCheckInfo(3)
    }
    if (this.parentData.process_stage === 'check_process_wcp') {
      this.getZuliCheckInfo(4)
      this.getZuliImage(4)
      this.getZuliPointList()
      this.getZuliDiagonalInfo()
    }
    if (this.parentData.process_stage === 'zhongdian1') {
      this.getZuliCheckInfo(5)
    }
    if (this.parentData.process_stage === 'zhongdian2') {
      this.getZuliCheckInfo(6)
    }
    if (this.parentData.process_stage === 'zhongdian3') {
      this.getZuliCheckInfo(7)
    }
  }
}
</script>

<style scoped>
.checkInfo {
  background-color: #F4F8FD;
  padding-top: 2px;
}

.detail {
  background-color: #FFFFFF;
  margin: 5px;
  border-radius: 5px;
  padding: 5px;
  font-size: 16px;
}

.detailDiv {
  width: 50%;
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fontBold {
  font-weight: bold;
}

.width1 {
  width: 25%;
}

.width2 {
  width: 39%;
}

.width3 {
  width: 12.5%;
}

.width4 {
  width: 30%;
}

.width5 {
  width: 50%;
}

.nowrapDiv {
  display: flex;
  flex-wrap: nowrap;
}

.ngdiv {
  width: 50px;
  height: 25px;
  background-color: #F1F1F1;
  margin-right: 5px;
  margin-bottom: 5px;
}

.ngdiv1 {
  font-size: 12px;
  width: 50px;
  height: 25px;
  background-color: #1A73E8;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
}

.imageStyle {
  width: 87px;
  height: 87px;
  margin-right: 5px
}

.imageStyle1 {
  width: 500px;
  height: 500px;
  margin-right: 5px
}

>>> .el-tabs--border-card > .el-tabs__content {
  padding: 1px !important;
}
</style>
